import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFlightStatus from './flight-status.reducer';

export const selectFlightStatusState = createFeatureSelector<fromFlightStatus.FlightStatusState>('flightStatus');

export const selectFlightStatuses = createSelector(selectFlightStatusState, (state) => {
  return state.flightStatuses;
});
